export const firstCapitalLetter = text =>
  text.charAt(0).toUpperCase() + text.slice(1);
